export const SUBSCRIPTION_PACKAGES = [
    {
        title: 'Dane a účtovníctvo',
        key: 'taxes',
        moduleId: 'taxes',
        color: '#F2941A',
        saleBoxBackground: '#FAEFE1',
        redirectLink:
            '/skolenia?rocne_predplatne=taxes',
        icon: 'D',
        benefits: [
            '<span class="bold">100+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=taxes">Zobraziť najbližšie školenia</a>',
            'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>',
            '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat',
            '<span class="bold">Videozáznamy</span> <br /> a školiace materiály',
            '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia',
        ],
        price: '527,67',
        priceWithoutVat: '429',
        eso9: 'SRPVDAUEPI000'
    },
    {
        title: 'Mzdy a personalistika',
        key: 'wages',
        moduleId: 'wages',
        color: '#F00035',
        saleBoxBackground: '#F7DADA',
        redirectLink:
            '/skolenia?rocne_predplatne=wages',
        icon: 'M',
        benefits: [
            '<span class="bold">100+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=wages">Zobraziť najbližšie školenia</a>',
            'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>',
            '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat',
            '<span class="bold">Videozáznamy</span> <br /> a školiace materiály',
            '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia',
        ],
        price: '527,67',
        priceWithoutVat: '429',
        eso9: 'SRPVMAPEPI000'
    },
    {
        title: 'Verejná správa',
        key: 'government',
        moduleId: 'government',
        color: '#63BF4D',
        saleBoxBackground: '#E7F5E4',
        redirectLink:
            '/skolenia?rocne_predplatne=government',
        icon: 'V',
        benefits: [
            '<span class="bold">150+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=government">Zobraziť najbližšie školenia</a>',
            'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>',
            '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat',
            '<span class="bold">Videozáznamy</span> <br /> a školiace materiály',
            '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia',
        ],
        garantLogo: 'zmos.png',
        price: '527,67',
        priceWithoutVat: '429',
        eso9: 'SRPVVSEPI000'
    },
];

export const SUBSCRIPTION_PACKAGES_KEYS = ['taxes', 'wages', 'government'];

export const SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
    TAXES: 'taxes',
    WAGES: 'wages',
    GOVERNMENT: 'government',
};
